import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { BalconyFilter } from '../../../../models/Filter';
import { BalconyNewFilter } from '../../desktop/balcony/BalconyNewFilter';

interface IBalconyFilter {
    filter: BalconyFilter;
    handleChange: (value: BalconyFilter) => void;
    classNameGroup?: string;
}

export const MobileBalconyFilterButtonView: React.FC<IBalconyFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Балкон'>
            <BalconyNewFilter
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
